import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import localeFR from '@angular/common/locales/fr';
import localeNL from '@angular/common/locales/nl';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeNL, 'nl');
registerLocaleData(localeEN, 'en');
registerLocaleData(localeDE, 'de');
registerLocaleData(localeFR, 'fr');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err: any) => console.error(err));
